export default "<div >\n    <ngx-gallery [options]=\"galleryOptions\" [images]=\"images\"></ngx-gallery>\n</div>"